module.exports = __webpack_public_path__ + "img/BNP.75c6d5c8.png";